'use client';

import { NavigableButton } from '@carvana/ds-button';
import cx from 'classnames';
import { testDriveCenterImages } from '~/constants/dealership/testDriveCenter/assets';
import optimizeImage from '~/utilities/optimizeImage';
import styles from '../TestDriveCenter.module.css';

const section = 'Test Drive Center - Hero';

const heroBackground = optimizeImage(testDriveCenterImages.heroLanes, {
  format: 'auto',
  optimize: 'medium'
});

export default function TestDriveCenterHero() {
  return (
    <section className="relative flex h-screen min-h-[640px] items-end overflow-hidden">
      <div
        className={cx(styles.heroBg, 'absolute inset-0 will-change-transform')}
        style={{ backgroundImage: `url('${heroBackground}')` }}
      />
      <div className={cx(styles.heroScrim, 'absolute inset-0')} />
      <div
        className={cx(
          styles.heroContent,
          'relative mx-auto w-full max-w-[1320px] px-[clamp(20px,4vw,56px)] pb-[clamp(48px,7vh,96px)] will-change-transform'
        )}
      >
        <h1
          className={cx(
            styles.heroTitle,
            'mb-[26px] max-w-[14ch] font-[family-name:var(--font-display)] text-[clamp(54px,9.4vw,150px)] font-black uppercase leading-[0.86] tracking-[-0.025em] text-white'
          )}
        >
          Car Shopping, Reimagined.
        </h1>
        <p className="mb-36 max-w-[540px] text-[clamp(17px,1.55vw,22px)] font-normal leading-[1.5] text-white/90">
          Test drive on-site, buy online and get it delivered.
        </p>
        <div className="flex flex-wrap items-center gap-[14px]">
          <NavigableButton
            data-adobe-id="shop-new-cars"
            data-analytics-id={`${section} - Shop New Cars`}
            data-testid="test-drive-center-hero-search-cars"
            href="/cars"
            size="lg"
            variant="primary"
          >
            Shop New Cars
          </NavigableButton>
        </div>
      </div>
    </section>
  );
}
